import { Stack, Typography } from '@mui/material';
import React from 'react';

interface InputAreaProps extends React.PropsWithChildren {
  name: string;
  description: string;
}

export function InputArea(props: InputAreaProps) {
  return (
    <Stack gap={1} sx={{}}>
      <Stack>
        <Typography variant="h6">{props.name}</Typography>
        <Typography whiteSpace="break-spaces">{props.description}</Typography>
      </Stack>
      {props.children}
    </Stack>
  );
}
